/* VTILTED verified storefront bug fixes — 2026-08-21 */
(function () {
  'use strict';

  // The old predictive-search renderer appended &width=160 even when the image
  // URL had no query string. Repair those URLs as results are inserted.
  function fixPredictiveSearchImages(root) {
    (root || document).querySelectorAll('.vt-row__img img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if (src.indexOf('&width=160') !== -1 && src.indexOf('?') === -1) {
        img.setAttribute('src', src.replace('&width=160', '?width=160'));
      }
    });
  }

  function initSearchImageRepair() {
    var results = document.querySelector('[data-vt-results]');
    if (!results) return;
    fixPredictiveSearchImages(results);
    if (!results.__vtImageRepairObserver) {
      results.__vtImageRepairObserver = new MutationObserver(function () {
        fixPredictiveSearchImages(results);
      });
      results.__vtImageRepairObserver.observe(results, { childList: true, subtree: true });
    }
  }

  // Search template had two identical ProductGridContainer IDs. Keep the outer
  // container as the stable AJAX target and strip the duplicate IDs.
  function fixDuplicateProductGridIds() {
    var grids = document.querySelectorAll('[id="ProductGridContainer"]');
    for (var i = 1; i < grids.length; i++) {
      grids[i].removeAttribute('id');
      grids[i].setAttribute('data-vt-product-grid-inner', '');
    }
  }

  // The alternate header mark is no longer part of the header. Clear any stale
  // class left behind by older code; CSS also protects against it reappearing.
  function clearRetiredLogoState() {
    document.body.classList.remove('vt-scrolled');
  }

  function e164(raw) {
    var digits = (raw || '').replace(/[^0-9]/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if ((raw || '').charAt(0) === '+' && digits.length >= 8) return '+' + digits;
    return null;
  }

  // The original SMS block showed success immediately, even when Klaviyo failed.
  // Capture the submit first and only show success after Klaviyo confirms the request.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('.vt-sms__form');
    if (!form) return;
    var section = form.closest('[data-vtsms]');
    if (!section) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var phone = section.querySelector('.vt-sms__phone');
    var note = section.querySelector('.vt-sms__note');
    var consent = section.querySelector('.vt-sms__consent');
    var success = section.querySelector('.vt-sms__success');
    var button = form.querySelector('button[type="submit"]');
    var number = e164(phone ? phone.value.trim() : '');

    if (!number) {
      if (note) {
        note.hidden = false;
        note.textContent = 'Enter a valid mobile number.';
        note.classList.add('is-error');
      }
      return;
    }

    if (button) button.disabled = true;
    if (note) {
      note.hidden = false;
      note.textContent = 'Adding you…';
      note.classList.remove('is-error');
    }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(section.dataset.klCompany || ''), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'SMS Signup',
            profile: { data: { type: 'profile', attributes: { phone_number: number } } }
          },
          relationships: {
            list: { data: { type: 'list', id: section.dataset.klSmsList } }
          }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
      form.hidden = true;
      if (note) note.hidden = true;
      if (consent) consent.hidden = true;
      if (success) success.hidden = false;
    }).catch(function (error) {
      console.warn('VTILTED SMS signup error', error);
      if (button) button.disabled = false;
      if (note) {
        note.hidden = false;
        note.textContent = "Couldn't add you right now. Please try again.";
        note.classList.add('is-error');
      }
    });
  }, true);

  function initFixes() {
    clearRetiredLogoState();
    initSearchImageRepair();
    fixDuplicateProductGridIds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFixes);
  } else {
    initFixes();
  }

  document.addEventListener('shopify:section:load', function () {
    initSearchImageRepair();
    fixDuplicateProductGridIds();
  });
})();
